import React, { useEffect, useState, useMemo } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { get } from "../../api/request";
import ImageGrid from "./ImageGrid";
import VideoPlayer from "./VideoPlayer";
import { Helmet } from "react-helmet-async";
import "./styles.css";
const defaultAvatar = require("../../imgs/section_icon.png");
const PetMoment = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [comments, setComments] = useState([]);
  const [showLikeModal, setShowLikeModal] = useState(false);

  useEffect(() => {
    console.log(window.location.href);

    async function fetchData() {
      try {
        const token = searchParams.get("t");
        if (token) {
          let result = await get("/api/share/moment/detail", {
            t: token,
          });
          console.log("result", result);
          setData(result.data);
          let comment = await get("/api/share/moment/comment/list", {
            t: token,
          });
          console.log("comment: ", comment);
          setComments(comment.data);
        }
      } catch (error) {
        console.error("获取moment失败：", error);
      }
    }
    fetchData();
  }, [searchParams]);

  const CommentItem = ({ item }) => {
    return (
      <>
        <div className="commentItem">
          <img
            src={item.photo || defaultAvatar}
            alt="用户头像"
            className="avatar"
          />
          <div className="commentContent">
            <div>
              <p className="username">{item.nickName}</p>
              <p className="commentText">{item.content}</p>
              <div className="commentFooter">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "30px",
                  }}
                >
                  <span className="commentTime">{item.createTimeDisplay}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {item.replyList?.map((reply) => (
            <div key={reply.id} className="replyItem">
              <img
                src={reply.photo || defaultAvatar}
                alt="回复用户头像"
                className="avatar"
              />
              <div className="commentContent">
                <p className="username">
                  {reply.nickName} 回复 {reply.replyToNickName}
                </p>
                <p className="commentText">{reply.content}</p>
                <div className="commentFooter">
                  <span className="commentTime">{reply.createTimeDisplay}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  /** 与 RN 详情一致：photos 缺 imageUrl 时用同索引 images 补上；展示用 imagesToShow + photosForGrid */
  const { imagesToShow, photosForGrid } = useMemo(() => {
    const imagesLegacy = Array.isArray(data?.images) ? data.images : [];
    const detailPhotos =
      Array.isArray(data?.photos) && data.photos.length > 0
        ? data.photos
        : null;
    const detailPhotosForGrid = detailPhotos
      ? detailPhotos.map((p, i) => ({
          ...p,
          imageUrl: p?.imageUrl || imagesLegacy[i] || null,
        }))
      : null;
    const imagesToShowComputed =
      detailPhotosForGrid?.map((p) => p?.imageUrl ?? null) ?? imagesLegacy;
    return {
      imagesToShow: imagesToShowComputed,
      photosForGrid: detailPhotosForGrid,
    };
  }, [data]);

  // 加载中状态
  if (!data) return <div>加载中...</div>;
  return (
    <>
      <Helmet>
        <title>{`伴知宠 - ${data?.petName}的日常`}</title>
        <meta
          property="og:title"
          content={`伴知宠 - ${data?.petName}的可爱日常`}
        />
        <meta property="og:description" content="快来围观萌宠的精彩瞬间！" />
        <meta property="og:image" content={data?.thumbnailUrl} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="pet-moment-page">
        <div className="guide_box">
          <div className="left_box">
            <span className="pet_icon"></span>
            <span>和我一起使用伴知宠吧</span>
          </div>
          <span className="download_app">下载APP</span>
        </div>
        {data?.contentType === "image" && (
          <ImageGrid
            images={imagesToShow}
            photos={photosForGrid || undefined}
          />
        )}
        {data?.contentType === "video" && (
          <VideoPlayer
            videoURL={data?.videoUrl}
            videoCover={data?.videoCover}
          />
        )}
        <div className="moment-operation">
          <span className="birth-box">
            <span>{data?.createTimeDisplay}</span>
            <span style={{ color: "rgba(0,0,0,0.5)" }}>{data?.ageDisplay}</span>
          </span>
          <span className="like-box">
            <span
              className="like-list-box"
              onClick={() => {
                setShowLikeModal(true);
              }}
            >
              {data?.likeList.map((item, index) => (
                <span
                  className={`like_member ${
                    index === data.likeList.length - 1 ? "last-item" : ""
                  }`}
                  style={{
                    zIndex: 100 - index,
                    ...(item.photo && {
                      backgroundImage: `url(${item.photo})`,
                    }),
                  }}
                ></span>
              ))}
            </span>
            <span
              className={`like-icon ${data?.isLiked ? "like-active" : "like"}`}
            ></span>
            <span className="like-count">{data?.likeCount || 0}</span>
          </span>
        </div>
        <div className="desc">
          <p>{data?.description}</p>
        </div>
        <div className="commentList">
          {comments.map((item) => (
            <CommentItem key={item.id} item={item} />
          ))}
        </div>
        {showLikeModal && (
          <LikeModal
            showLikeModal={showLikeModal}
            setShowLikeModal={setShowLikeModal}
            likeList={data?.likeList || []}
          />
        )}
      </div>
    </>
  );
};
const LikeModal = ({ showLikeModal, setShowLikeModal, likeList }) => {
  // 关闭弹窗
  const handleCloseModal = () => {
    setShowLikeModal(false);
  };

  return (
    // 模态框容器 - 仅在显示时渲染
    showLikeModal && (
      <div className="modal-overlay" onClick={handleCloseModal}>
        {/* 阻止点击内容区域关闭弹窗 */}
        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
          {/* 弹窗标题栏 */}
          <div className="likeBoxTitle">
            <span></span>
            <span style={{ fontSize: "18px" }}>点赞人</span>
            <button className="close-btn" onClick={handleCloseModal}>
              <img
                src={require("../../imgs/close.png")}
                alt="关闭"
                className="closeIcon"
              />
            </button>
          </div>

          {/* 点赞人列表滚动区域 */}
          <div className="like-list-scroll">
            {likeList.map((item) => (
              <div key={item.userId} className="likeItem">
                <div className="likeItemContent">
                  <img
                    src={item.photo || defaultAvatar}
                    alt={item.nickName}
                    className="avatarLikeList"
                  />
                  <span>{item.nickName}</span>
                </div>
                <span className="like-time">{item.createTimeDisplay}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};
export default PetMoment;
